<style lang="scss">
.resourse-file-list-wrap {
  height: 350px;
  padding: 10px;
  border: 2px solid #dfdfdf;
  overflow-y: scroll;
  border-radius: 5px;
}
</style>
<template>
  <div id="exhibitor-edit-tab-resource">
    <div class="vx-row">
      <div class="vx-col md:w-1/1 w-full">
        <div class="custom-head-wrap mb-5">
            <h1 class="cms-custom-heading">
                {{data_local.Name}}
            </h1>
        </div>
        <div class="custom-head-wrap mb-5">
            <h2 class="cms-custom-heading">
                Upload Resources
            </h2>
            <p class="mt-1 mb-0">Supported File types: .csv, .excel,.xlsx,.pdf,.doc,.docx</p>
        </div>
        <!-- <h3>Upload Resources</h3>
        <label>Supported File types: .csv, .excel,.xlsx,.pdf,.doc,.docx</label> -->
        <div class="vx-row">
          <div class="vx-col md:w-1/2 mt-6">
            <div class="upload-area-wrap exhibit-resource-upload">
              <input
                type="file"
                multiple
                class="hidden"
                ref="update_resource_input"
                @change="upload_resources"
              />
              <vs-button
                class="mr-4 mb-4"
                @click="$refs.update_resource_input.click()"
                >Upload Resources</vs-button
              >
            </div>
          </div>
          <div class="vx-col md:w-1/2 mb-3">
            <label>Uploaded Resources (Drag and drop to reorder)</label>
            <div class="resourse-file-list-wrap resource-custom-file-upload">
              <div v-if="data_local.Resources.length || ResourcesLink.length">  
                <draggable
                  :list="data_local.Resources"
                  :group="{ name: 'tags' }"
                  class="p-2 cursor-move menu-dragbox exhibitor-menu-dragbox"
                >              
                  <div
                    class="single-file-wrap"
                    v-for="file in data_local.Resources"
                  >
                    <div class="file-sec-wrap">
                      <a :href="file.name ? '#' : file">{{
                        file.name ? file.name : getFileName(file)
                      }}</a>
                      <a href="#"
                        ><img
                          @click="deleteFile(file)"
                          src="../../assets/images/delete.svg"
                      /></a>
                    </div>
                  </div>              
                </draggable>
                <draggable
                  :list="data_local.Resources"
                  :group="{ name: 'tags' }"
                  class="p-2 cursor-move menu-dragbox exhibitor-menu-dragbox"
                >
                  <div
                    class="single-file-wrap"
                    v-for="resource in ResourcesLink" 
                  >
                    <div class="file-sec-wrap">

                      <a :href="resource.Link" target="_blank">{{resource.Title}}</a>
                      <a href="#"
                        ><img
                          @click="deleteLink(resource)"
                          src="../../assets/images/delete.svg"
                      /></a>
                    </div>
                  </div>
                </draggable>
              </div>
              <div v-else>No Resources uploaded yet!</div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/1 w-full">
        <div class="vx-row">
          <!-- Col 1 -->
          <div class="vx-col w-full md:w-4/12 mt-4">
            <vs-input
              class="w-full"
              label="Title"
              name="title"
              v-model="exhibitorResourceTitle"
            />
          </div>
          <div class="vx-col w-full md:w-4/12 mt-4">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link"
              label="Link"
              icon-no-border
              v-model="exhibitorResourceLink"
            />
          </div>
          <div class="vx-col w-full md:w-4/12 mt-5">
            <vs-button class="ml-auto mt-5" @click="add_link">Add</vs-button>
          </div>
        </div>
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="mt-2" @click="$router.push('/event/exhibitors')"
            >Back To List</vs-button
          >
          <vs-button
            class="ml-auto mt-2"
            @click="save_changes(true)"
            :disabled="!validateForm"
            color="success"
          >Save & Continue</vs-button>
          <vs-button class="ml-4 mt-2" @click="save_changes(false)"  color="success"
            >Save & Exit</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import draggable from "vuedraggable";

import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";

export default {
  components: {
    vSelect,
    quillEditor,
    draggable,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    console.log("data====",JSON.parse(JSON.stringify(this.data)).ResourcesLink)
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      ResourceFiles: [],
      exhibitorResourceLink: null,
      exhibitorResourceTitle: null,
      ResourcesLink: JSON.parse(JSON.stringify(this.data)).ResourcesLink != undefined && JSON.parse(JSON.stringify(this.data)).ResourcesLink.length > 0 ? JSON.parse(JSON.stringify(this.data)).ResourcesLink : []
    };
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    successUpload() {
      this.$vs.notify({ color: "success", title: "Successfully Uploaded" });
    },
    deleteFile(file) {
      let name = "";
      if (file.name) {
        name = file.name;
      } else {
        name = file;
        const Id = this.$route.params.exhibitorId;
        if (Id) {
          this.$vs.loading();
          this.$store
            .dispatch("exhibitorManagement/deleteResource", {
              id: Id,
              name: name,
            })
            .then((res) => {
              this.$vs.loading.close();
              let index = this.data.Resources.indexOf(name);
              this.data.Resources.splice(index, 1);
            })
            .catch((err) => {
              console.error(err);
            });
        }
      }
      let index = this.data_local.Resources.indexOf(name);
      this.data_local.Resources.splice(index, 1);
      let index2 = this.ResourceFiles.indexOf(name);
      this.ResourceFiles.splice(index2, 1);
    },
    getFileName(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
    upload_resources(input) {
      if (input.target.files.length) {
        for (var i = 0; i < input.target.files.length; i++) {
          const file = input.target.files[i];
          const metadata = {
            contentType: file.type,
          };
          //console.log(file)
          let filename = file.name;
          filename = filename.split(".").pop();
          //console.log(filename)
          /*const validImageTypes = ['csv', 'pdf', 'xlsx', 'excel', 'doc', 'docx']
          if (!validImageTypes.includes(filename)) {
            alert('Only files allowed.')
            return false
          }*/
          let FileSize = file.size / 1024 / 1024;
          if (FileSize > 20) {
            alert("Uploaded file size exceeds 20 MB");
            return false;
          }
          this.data_local.Resources.push(file);
          this.ResourceFiles.push(file);
        }
      }
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes(form_continue = false) {
      /* eslint-disable */
      if (!this.validateForm) return;
      debugger;
      if (this.ResourcesLink.length > 0) {
        this.data_local.ResourcesLink = this.ResourcesLink;
      }else{
        this.data_local.ResourcesLink = [];
      }

      this.$vs.loading();
      this.data_local.ResourceFiles = this.ResourceFiles;
      this.ResourceFiles = [];

      const Id = this.$route.params.exhibitorId;
      //alert(Id);
      if (Id) {
        this.$store
          .dispatch("exhibitorManagement/updateExhibitor", {
            id: Id,
            data: this.data_local,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Exhibitor",
              text: "Exhibitor resource updated successfully.",
            });
            this.$vs.loading.close();
            if(form_continue)
              this.$emit('activateTab', 2);              
            else
              this.$router.push("/event/exhibitors/");
          })
          .catch((err) => {
            console.error(err);
          });
      } 
      else
      {
        this.$vs.loading.close();
        this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Exhibitor",
              text: "Not possible to update!",
            });
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc = this.data.Logo;
    },
    add_link() {
      if(this.exhibitorResourceTitle && this.exhibitorResourceLink){
        this.ResourcesLink.push({
          Id: this.ResourcesLink.length + 1,
          Title: this.exhibitorResourceTitle,
          Link: this.exhibitorResourceLink,
        });
        this.exhibitorResourceTitle = null;
        this.exhibitorResourceLink = null;
      }
    },
    deleteLink(resource) {
        let name = "";
        let link = "";
        name = resource.Title;
        link = resource.Link;
        const Id = this.$route.params.exhibitorId;
        if (Id) {
          this.$vs.loading();
          this.$store
            .dispatch("exhibitorManagement/deleteResource", {
              id: Id,
              name: name,
              fileLink: link,
              link: true,
            })
            .then((res) => {
              this.$vs.loading.close();
              let index2 = this.ResourcesLink.findIndex(i => i.Title == name);
              this.ResourcesLink.splice(index2, 1);
              console.log("link======s====",this.ResourcesLink);
            })
            .catch((err) => {
              console.error(err);
            });
        }
    },
  },
  created() {},
};
</script>